import {greys} from '../../styles/colorStyles';

export const LIGHT_APP_FOREGROUND_COLOR = greys.white;
